/*
 * Roché navigation helpers (desktop mega menu + dropdowns, mobile drawer).
 * The theme already opens submenus on :hover and :focus-within (assets/header.css).
 * This adds what CSS alone cannot:
 *   - aria-expanded kept in sync on each parent link
 *   - Escape closes the open submenu (desktop) or the menu drawer (mobile)
 *   - touch: first tap on a parent opens its submenu, second tap follows the link
 */
(function () {
  var desktop = window.matchMedia('(min-width: 1025px)');

  function parentLink(item) {
    return item.querySelector(':scope > [data-roche-nav-parent]');
  }

  function setOpen(item, open) {
    var link = parentLink(item);
    if (link) link.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!open) item.classList.remove('active');
  }

  function allItems() {
    return document.querySelectorAll('[data-roche-nav-item]');
  }

  function closeAll(except) {
    allItems().forEach(function (item) {
      if (item !== except) setOpen(item, false);
    });
  }

  function initItem(item) {
    var link = parentLink(item);
    if (!link) return;

    item.addEventListener('mouseenter', function () {
      item.classList.remove('roche-nav-suppress');
      setOpen(item, true);
    });

    item.addEventListener('mouseleave', function () {
      item.classList.remove('roche-nav-suppress');
      setOpen(item, false);
    });

    item.addEventListener('focusin', function () {
      if (!item.classList.contains('roche-nav-suppress')) setOpen(item, true);
    });

    item.addEventListener('focusout', function (event) {
      if (!item.contains(event.relatedTarget)) {
        item.classList.remove('roche-nav-suppress');
        setOpen(item, false);
      }
    });

    link.addEventListener('pointerdown', function (event) {
      item.dataset.rocheTouch = event.pointerType === 'touch' ? 'true' : 'false';
    });

    link.addEventListener('click', function (event) {
      if (!desktop.matches) return;
      if (item.dataset.rocheTouch === 'true' && !item.classList.contains('active')) {
        event.preventDefault();
        closeAll(item);
        item.classList.remove('roche-nav-suppress');
        item.classList.add('active');
        setOpen(item, true);
      }
    });
  }

  function onKeydown(event) {
    if (event.key !== 'Escape') return;

    if (document.body.classList.contains('mobile-menu-active')) {
      var closeBtn = document.querySelector('[data-mobile-menu-close]');
      if (closeBtn) closeBtn.click();
      return;
    }

    var focused = document.activeElement && document.activeElement.closest('[data-roche-nav-item]');
    allItems().forEach(function (item) {
      if (item === focused || item.classList.contains('active') || item.matches(':hover')) {
        item.classList.add('roche-nav-suppress');
        setOpen(item, false);
      }
    });
    if (focused && parentLink(focused)) parentLink(focused).focus();
  }

  function init() {
    allItems().forEach(initItem);
    document.addEventListener('keydown', onKeydown);
    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-roche-nav-item]')) closeAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
